<template>
  <div>
    <GlobalForm
      class="global-form"
      :init-data="initData"
      :form-item-list="formItemList"
      :inline="true"
      :labelWidth="100"
      :needBtnLoading="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
      <el-form-item
        label="执行门店"
        slot="storeId"
        style="margin:0"
      >
        <el-select
          filterable
          :popper-append-to-body="false"
          v-model="storeId"
          placeholder="请选择执行门店"
          clearable
        >
          <el-option
            v-for="item in storeList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-button
        icon="el-icon-plus"
        slot="AddSlot"
        type="primary"
        @click="addGiftBag"
        >新增礼包</el-button
      >
      <el-button
        slot="AddSlot"
        type="warning"
        @click="goGiftManage"
        >赠品管理</el-button
      >
    </GlobalForm>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";
export default {
  data() {
    return {
      initData: {},
      storeList: [],
      storeId: "",
      formItemList: [
        {
          key: "giftPackName",
          type: "input",
          labelName: "礼包名称",
          placeholder: "请输入礼包名称",
        },
        {
          slotName: "storeId",
        },
        {
          key: "entryTime",
          type: "pickerOptions",
          labelName: "创建时间",
          clearable: true
        },
      ],
    };
  },
  created() {
    this.getAllStoreSelectList()
  },
  mounted() {},
  methods: {
    handleConfirm(data,cd) {
      let startTime = "";
      let endTime = "";
      if(data){
        if (data.entryTime == null) {
          (startTime = ""), (endTime = "");
        } else {
          (startTime = moment(data.entryTime[0]).format("x")),
            (endTime = moment(data.entryTime[1]).format("x"));
        }
      }
      let SeachParams = {
        startTime: startTime,
        endTime: endTime,
        giftPackName: data && data.giftPackName || "",
        storeId: this.storeId,
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        }
      };
      this.$store.commit("tagsView/SEACH_PARAMS", SeachParams);
    },
    // 获取全部门店
    getAllStoreSelectList() {
      _api.getAllStoreSelectList().then(res => {
        if(res.code == 1){
          this.storeList = res.data
        }
      })
    },
    //新增礼包
    addGiftBag() {
      this.$router.push("/OnlinreyService/addGiftBag");
    },
    // 去赠品管理
    goGiftManage() {
      let routeData = this.$router.resolve({
        path: "/OnlinreyService/giftManage"
      });
      window.open(routeData.href, "_blank");
    }
  },
};
</script>

<style lang="scss" scoped>
.global-form {
  /deep/.el-input__inner {
    width: 160px;
  }
}
</style>
